module.exports = __webpack_public_path__ + "static/media/expired_bg.e5f458fa.png";